import { Flex } from 'antd';
import { FC } from 'react';
import type { Study } from '@/models/study';
import { Tag } from '@/shared/ui/Tag';

interface Props {
  study: Study;
  compact?: boolean;
}

const StudyTagsCell: FC<Props> = ({ study, compact = false }) => {
  if (!study.tags || study.tags.length === 0) return <>—</>;

  return (
    <Flex gap={4} wrap>
      {study.tags.map((tag) => (
        <Tag
          key={tag.value}
          value={tag.value}
          source={tag.source}
          compact={compact}
        />
      ))}
    </Flex>
  );
};

export default StudyTagsCell;
